var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsBottomDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 232,
    viewBox: "0 0 1920 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4790_18093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-101.745 22.7867L-355.109 117.179C-358.41 118.409 -361.574 115.081 -360.178 111.846L-183.86 -296.799C-183.228 -298.264 -181.784 -299.214 -180.187 -299.214H2272.83C2275.04 -299.214 2276.83 -297.423 2276.83 -295.214V19.9389C2276.83 21.518 2275.9 22.9492 2274.46 23.5923L2062.85 117.941C2060.2 119.121 2057.22 117.185 2057.22 114.288V28.2144C2057.22 25.4474 2054.48 23.5161 2051.87 24.4482L1788.89 118.538C1786.28 119.47 1783.54 117.539 1783.54 114.772V26.5351C1783.54 24.3259 1781.75 22.5351 1779.54 22.5351H1377.27C1376.91 22.5351 1376.56 22.5826 1376.21 22.6765L1023.45 119.07C1020.9 119.766 1018.39 117.85 1018.39 115.212V26.5351C1018.39 24.3259 1016.6 22.5351 1014.39 22.5351H568.33C567.878 22.5351 567.429 22.6117 567.003 22.7617L294.593 118.577C291.991 119.493 289.266 117.562 289.266 114.804V26.5351C289.266 24.3259 287.475 22.5351 285.266 22.5351H-100.348C-100.825 22.5351 -101.298 22.6203 -101.745 22.7867Z",
    fill: "#2F5D42"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4790_18093)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1635.91,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1519.48,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403.04,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1403.04,
    y: 178.072,
    width: 342.316,
    height: 226.362,
    fill: "url(#paint0_linear_4790_18093)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 864.731,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    rx: 5,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.293,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    rx: 5,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.858,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    rx: 5,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.858,
    y: 178.072,
    width: 342.316,
    height: 226.362,
    rx: 5,
    fill: "url(#paint1_linear_4790_18093)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.266,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8284,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96.6072,
    y: 36.6128,
    width: 107.562,
    height: 134.102,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96.6072,
    y: 178.072,
    width: 342.316,
    height: 226.362,
    fill: "url(#paint2_linear_4790_18093)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4790_18093",
    x1: 1574.2,
    y1: 178.072,
    x2: 1574.2,
    y2: 404.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4790_18093",
    x1: 803.016,
    y1: 178.072,
    x2: 803.016,
    y2: 404.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4790_18093",
    x1: 74.551,
    y1: 178.072,
    x2: 74.551,
    y2: 404.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4790_18093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1922,
    height: 232,
    fill: "white",
    transform: "translate(-2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4790_18093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1842,
    height: 178,
    fill: "white",
    transform: "translate(-97 37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsBottomDivider);
export default __webpack_public_path__ + "static/media/news_bottom_divider.85838ac0c4d468e08dae031fd89d2d2f.svg";
export { ForwardRef as ReactComponent };